import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Wrapper = styled.div`
  margin-bottom: 30px;

  ul {
    display: flex;
    font-size: 13px;
    color: ${({theme}) => theme.colors.grayscale[700]};

    button {
      color: ${({theme}) => theme.colors.grayscale[700]};
    }

    li {
      display: flex;
      align-items: center;

      &:after {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        background-image: url(/assets/base/breadcrumbs.svg);
        background-size: 100% auto;
        background-position: center center;
        background-repeat: no-repeat;
      }

      &:last-child:after {
        display: none;
      }
    }
  }

  > p {
    font-size: 24px;
    font-weight: 600;
    color: ${({theme}) => theme.colors.grayscale[600]};
  }
  
  button {
    height: 24px;
  }
`;